module.exports = __webpack_public_path__ + "static/media/1.03152055.jpeg";